/* 
* <license header>
*/

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import ReactDOM from 'react-dom'

import Runtime, { init } from '@adobe/exc-app'

import App from './components/App'
import { initWebMcp, toolRegistry, webMcpAdapter } from './webmcp/index.js'
import { sendBeacon, trackToolUsage } from './analytics/beacon.js'
import './index.css'

window.React = require('react')

// Register the agent tool surface as early as possible so an AI client that
// attaches on load already sees the tools. Never let it block rendering.
// connect() never rejects, so the view is counted either way. Waiting for it
// costs about a second and buys the one field that matters: whether this browser
// has native WebMCP, meaning the visitor opened the app in ChatGPT Desktop.
initWebMcp()
  .then((status) => {
    sendBeacon({ transport: status.transport })
    trackToolUsage({ registry: toolRegistry, adapter: webMcpAdapter })
  })
  .catch((e) => {
    console.error('[webmcp] initialisation failed', e)
    sendBeacon()
  })
/* Here you can bootstrap your application and configure the integration with the Adobe Experience Cloud Shell */
try {
  // attempt to load the Experience Cloud Runtime
  require('./exc-runtime')
  // if there are no errors, bootstrap the app in the Experience Cloud Shell
  init(bootstrapInExcShell)
} catch (e) {
  console.log('application not running in Adobe Experience Cloud Shell')
  // fallback mode, run the application without the Experience Cloud Runtime
  bootstrapRaw()
}

function bootstrapRaw () {
  /* **here you can mock the exc runtime and ims objects** */
  const mockRuntime = { on: () => {} }
  const mockIms = {}

  // render the actual react application and pass along the runtime object to make it available to the App
  ReactDOM.render(
    <App runtime={mockRuntime} ims={mockIms} />,
    document.getElementById('root')
  )
}

function bootstrapInExcShell () {
  // get the Experience Cloud Runtime object
  const runtime = Runtime()

  // use this to set a favicon
  // runtime.favicon = 'url-to-favicon'

  // use this to respond to clicks on the app-bar title
  // runtime.heroClick = () => window.alert('Did I ever tell you you\'re my hero?')

  // ready event brings in authentication/user info
  runtime.on('ready', ({ imsOrg, imsToken, imsProfile, locale }) => {
    // tell the exc-runtime object we are done
    runtime.done()
    console.log('Ready! received imsProfile:', imsProfile)
    const ims = {
      profile: imsProfile,
      org: imsOrg,
      token: imsToken
    }
    // render the actual react application and pass along the runtime and ims objects to make it available to the App
    ReactDOM.render(
      <App runtime={runtime} ims={ims} />,
      document.getElementById('root')
    )
  })

  // set solution info, shortTitle is used when window is too small to display full title
  runtime.solution = {
    icon: 'AdobeExperienceCloud',
    title: 'MiniPaintWebMCP',
    shortTitle: 'JGR'
  }
  runtime.title = 'MiniPaintWebMCP'
}
